import { render, staticRenderFns } from "./ScoreBloc.vue?vue&type=template&id=2f59d479&scoped=true"
import script from "./ScoreBloc.vue?vue&type=script&lang=js"
export * from "./ScoreBloc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f59d479",
  null
  
)

export default component.exports